import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

export interface ProductFormData {
  name: string;
  plu: string;
  barcode: string;
  upcBarcode: string;
  nameShort: string;
  cost: string;
  desc: string;
  price: string;
  printName: string;
  size: string;
  slavePrintType: string;
  cover: string;
  itemType: string;
  img: string;
}

export const useProductForm = (initialValues?: Partial<ProductFormData>) => {
  const [isValidMainProduct, setIsValidMainProduct] = useState(true);
  const [isValidProduct, setIsValidProduct] = useState(true);
  const [isValidProductAvailability, setIsValidProductAvailability] =
    useState(true);
  const [isValidKiosk, setIsValidKiosk] = useState(true);
  const [color, setColor] = useState("");
  const [allYouCanEat, setAllYouCanEat] = useState(false);
  const [isByo, setIsByo] = useState(false);
  const [isCustomisationPriority, setIsCustomisationPriority] = useState(false);
  const [isSpicySelectionEnabled, setIsSpicySelectionEnabled] = useState(false);
  const [inTax, setInTax] = useState<any>({});
  const [outTax, setOutTax] = useState<any>({});
  const [selectedTags, setSelectedTags] = useState<any[]>([]);
  const [spotlightText, setSpotlightText] = useState("");
  const [selectedItemType, setSelectedItemType] = useState({});
  const [open, setOpen] = useState(false);

  const { register, handleSubmit, errors, reset, control } =
    useForm<ProductFormData>({
      defaultValues: {
        name: "",
        plu: "",
        barcode: "",
        upcBarcode: "",
        nameShort: "",
        cost: "",
        desc: "",
        price: "",
        printName: "",
        size: "",
        slavePrintType: "",
        cover: "",
        itemType: "",
        img: "",
        ...initialValues,
      },
    });

  // Add a function to reset form with new data
  const resetForm = (data: Partial<ProductFormData>) => {
    reset(data);
  };

  return {
    // States
    isValidMainProduct,
    setIsValidMainProduct,
    isValidProduct,
    setIsValidProduct,
    isValidProductAvailability,
    setIsValidProductAvailability,
    isValidKiosk,
    setIsValidKiosk,
    color,
    setColor,
    allYouCanEat,
    setAllYouCanEat,
    isByo,
    setIsByo,
    isCustomisationPriority,
    setIsCustomisationPriority,
    isSpicySelectionEnabled,
    setIsSpicySelectionEnabled,
    inTax,
    setInTax,
    outTax,
    setOutTax,
    selectedTags,
    setSelectedTags,
    spotlightText,
    setSpotlightText,
    selectedItemType,
    setSelectedItemType,
    open,
    setOpen,
    // Form methods
    register,
    handleSubmit,
    errors,
    reset,
    resetForm, // Export the new reset function
    control,
  };
};
